/**
 * @generated SignedSource<<e1e92e8ae6caa8460a14e6f142830d83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SetAlwaysPassContentConfigInput = {
  clientMutationId?: string | null | undefined;
  contentNodeId: string;
};
export type PassContentConfigEditor_SetAlwaysPassContentConfigMutation$variables = {
  input: SetAlwaysPassContentConfigInput;
};
export type PassContentConfigEditor_SetAlwaysPassContentConfigMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly setAlwaysPassContentConfig: {
        readonly contentNode: {
          readonly " $fragmentSpreads": FragmentRefs<"PassContentConfigEditor_TreeNodeFragment">;
        };
      } | null | undefined;
    };
  };
};
export type PassContentConfigEditor_SetAlwaysPassContentConfigMutation = {
  response: PassContentConfigEditor_SetAlwaysPassContentConfigMutation$data;
  variables: PassContentConfigEditor_SetAlwaysPassContentConfigMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PassContentConfigEditor_SetAlwaysPassContentConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "SetAlwaysPassContentConfigPayload",
                "kind": "LinkedField",
                "name": "setAlwaysPassContentConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "contentNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PassContentConfigEditor_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PassContentConfigEditor_SetAlwaysPassContentConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "SetAlwaysPassContentConfigPayload",
                "kind": "LinkedField",
                "name": "setAlwaysPassContentConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "contentNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "passConfig",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "configType",
                                    "storageKey": null
                                  },
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "requiredPercentage",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "OnPercentagePassContentConfig",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ContentTypeDefinition",
                            "abstractKey": "__isContentTypeDefinition"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b6e17909ed1fd22d2c03c0f73f7c7853",
    "id": null,
    "metadata": {},
    "name": "PassContentConfigEditor_SetAlwaysPassContentConfigMutation",
    "operationKind": "mutation",
    "text": "mutation PassContentConfigEditor_SetAlwaysPassContentConfigMutation(\n  $input: SetAlwaysPassContentConfigInput!\n) {\n  Admin {\n    Tree {\n      setAlwaysPassContentConfig(input: $input) {\n        contentNode {\n          ...PassContentConfigEditor_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment OnPercentagePassContentConfigForm_OnPercentagePassContentConfigFragment on OnPercentagePassContentConfig {\n  id\n  configType\n  requiredPercentage\n}\n\nfragment OnPercentagePassContentConfigForm_TreeNodeFragment on TreeNode {\n  id\n}\n\nfragment PassContentConfigEditor_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      passConfig {\n        __typename\n        configType\n        ... on OnPercentagePassContentConfig {\n          requiredPercentage\n        }\n        ...OnPercentagePassContentConfigForm_OnPercentagePassContentConfigFragment\n        id\n      }\n    }\n  }\n  ...OnPercentagePassContentConfigForm_TreeNodeFragment\n}\n"
  }
};
})();

(node as any).hash = "f67be25f1c713411c712fee18c6534ef";

export default node;
